/* eslint-disable array-callback-return */
const convertToQueryString = (json: any) => {
  let queryString = '';
  const stringCount = Object.keys(json).length - 1;
  Object.keys(json).forEach((item, index) => {
    if (Array.isArray(json[item])) {
      json[item].map((item2: unknown) => {
        if (item2) queryString += `${item}=${item2}${index < stringCount ? '&' : ''}`;
      });
    } else if (json[item] !== '') {
      queryString += `${item}=${json[item]}${index < stringCount ? '&' : ''}`;
    }
  });
  return queryString;
};

export const convertReverseToQueryString = (json: any) => {
  let queryString = '';
  const stringCount = Object.keys(json).length - 1;
  Object.keys(json).forEach((item, index) => {
    if (json[item] !== '') {
      queryString += `${json[item]}=${item}${index < stringCount ? '&' : ''}`;
    }
  });
  return queryString;
};

export const convertToQueryStringNew = (params: Record<string, any>) => {
  let queryString = '';
  const stringCount = Object.keys(params).length - 1;

  Object.keys(params).forEach((key, index) => {
    if (Array.isArray(params[key])) {
      (params[key] as number[]).forEach((item: number, idx: number) => {
        queryString += `${key}[]=${item}`;
        if (idx < (params[key] as number[]).length - 1) {
          queryString += '&';
        }
      });
    } else if (params[key] !== '') {
      queryString += `${key}=${params[key]}`;
    }

    if (index < stringCount) {
      queryString += '&';
    }
  });

  return queryString;
};

export const convertToQueryStringNew2 = (json: Record<string, any>) => {
  const queryParts: string[] = [];

  Object.keys(json).forEach((key) => {
    const value = json[key];

    if (Array.isArray(value)) {
      const filteredArray = value.filter((item) => item !== undefined && item !== null && item !== '');
      if (filteredArray.length > 0) {
        queryParts.push(`${key}[]=${filteredArray.map((item) => encodeURIComponent(item)).join(',')}`);
      }
    } else if (value !== undefined && value !== null && value !== '') {
      queryParts.push(`${key}=${encodeURIComponent(value)}`);
    }
  });

  return queryParts.join('&');
};

export default convertToQueryString;
